
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'
import * as gameActions from '../../../../Core/Game/game.actions'
import * as tutorialActions from '../../../../Tutorial/tutorial.actions'
import * as actions from '../phase0.actions'

class TutorialSelector extends React.Component {
  constructor(props) {
    super(props)
    this.startTutorial = this.startTutorial.bind(this)
    this.skipTutorial = this.skipTutorial.bind(this)
  }

  startTutorial() {
    const { addHowlSound, initTutorial, setTutorialPlayed } = this.props
    initTutorial()
    addHowlSound('button_click_icon')
    setTutorialPlayed()
  }

  skipTutorial() {
    const { next, addHowlSound, addPopup } = this.props
    addPopup('skip_tutorial_confirmation_popup')
    next()
    addHowlSound('button_click_icon')
  }

  render() {
    return (
      <div className="container background background--mars">
        <div className="content">
          <div className="mars--welcome">
            <div className="mars--init__title">
              <FormattedMessage id="welcome.text1" />
            </div>
            <div className="mars--welcome__message">
              <p className="text">
                <FormattedMessage id="phase.selectTutorialMessage" />
              </p>
            </div>
            <div className="mars--buttons">
              <div onClick={this.startTutorial} className="btn--orange">
                <span className="icon-rocket"></span>
                <span>
                  <FormattedMessage id={'phase.startTutorial'} />
                </span>
              </div>
              <div onClick={this.skipTutorial} className="btn--orange">
                <span className="icon-rocket"></span>
                <span>
                  <FormattedMessage id={'phase.skipTutorial'} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
    initTutorial: bindActionCreators(tutorialActions.initTutorial, dispatch),
    addPopup: bindActionCreators(gameActions.addPopup, dispatch),
    setTutorialPlayed: bindActionCreators(actions.setTutorialPlayed, dispatch),
  }
}

TutorialSelector.propTypes = {
  next: PropTypes.func,
  addHowlSound: PropTypes.func,
  initTutorial: PropTypes.func,
  addPopup: PropTypes.func,
  setTutorialPlayed: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(TutorialSelector))
